var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormItem',{attrs:{"prop":_vm.name,"label":_vm.label}},[_c('Input',_vm._g(_vm._b({ref:"formInput",staticClass:"cust-form-input",attrs:{"decorator":_vm.decorator}},'Input',_vm.$attrs,false),_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }